// Generate a unique identity.
function generateSvgDefId() {
  return '_tb_' + Math.random().toString(36).substr(2, 9);
}

export default generateSvgDefId;